export const fmt = (n) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Math.round(n));

export const fmtPct = (n) => {
  const v = parseFloat(parseFloat(n).toFixed(3));
  return v + "%";
};

export const generateId = () => Math.random().toString(36).substr(2, 9);

export const calculate = (item, sutaBases) => {
  const wageCap = sutaBases[item.state] || 0;
  const ee = item.employeeCount || 1;
  const avgWage = item.grossWages / ee;
  const taxablePerEE = Math.min(avgWage, wageCap);
  const totalTaxableWages = taxablePerEE * ee;
  const sutaTax = totalTaxableWages * (item.sutaRate / 100);
  const wcPremium = (item.grossWages / 100) * item.wcRate;
  return { wageCap, avgWage, totalTaxableWages, sutaTax, wcPremium };
};

export const sumItems = (items, sutaBases) =>
  items.reduce(
    (acc, item) => {
      const c = calculate(item, sutaBases);
      acc.grossWages += item.grossWages;
      acc.employees += item.employeeCount;
      acc.sutaTax += c.sutaTax;
      acc.wcPremium += c.wcPremium;
      acc.totalTaxableWages += c.totalTaxableWages;
      return acc;
    },
    { grossWages: 0, employees: 0, sutaTax: 0, wcPremium: 0, totalTaxableWages: 0 }
  );
